import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Table, Modal } from "react-bootstrap";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { CircularProgress } from "@material-ui/core";
import { userActions } from "../../redux";
import {
  deleteUserAsync,
  getUserAsync,
  useIsAccessAllow,
} from "../../redux/userApi";

const UserManagementTable = () => {
  const {
    subUserList,
    subUserSkip,
    subUserLimit,
    isSubUserLoading,
    isLoading,
    searchText,
  } = useSelector((state) => state.user, shallowEqual);
  const [DeleteModal, setDeleteModal] = useState(false);
  const deleteClose = () => setDeleteModal(false);
  const [flag, setFlag] = useState(false);
  // const deleteShow = () => setDeleteModal(true);
  const [selectedSubUser, setselectedSubUser] = useState({});
  const history = useHistory();
  const dispatch = useDispatch();
  const onPageChange = (pageIndex) => {
    const nextPage = Math.max(0, pageIndex);
    dispatch(userActions.setSubUserBatchNumber(nextPage));
  };

  const pageSizeOptions = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 150, label: "150" },
    { value: 200, label: "200" },
  ];

  const defaultPageSize = pageSizeOptions.find((option) => option.value === subUserLimit) || pageSizeOptions[0];

  const changePageSize = (option) => {
    dispatch(userActions.setSubUserLimit(option.value));
  };

  const totalRecords = subUserList?.recordsTotal || 0;
  const totalPages = Math.ceil(totalRecords / subUserLimit);
  const currentPage = subUserSkip + 1;
  const filteredUsers = useMemo(() => {
    if (!subUserList?.records) return [];
    return subUserList.records;
  }, [subUserList?.records]);
  useEffect(() => {
    setFlag(false);
    dispatch(getUserAsync(searchText));
  }, [flag]);
  const onEditClick = (subUser) => {
    dispatch(userActions.setSelectedSubUser(subUser));
    history.push(`/user/edit-user/${subUser?._id}`);
  };
  // const onDeleteClick = (subUser) => {
  //   setselectedSubUser(subUser);
  //   deleteShow();
  // };
  const onDeleteClick = (data) => {
    if (window.confirm("Are you sure you want to delete user?")) {
      dispatch(deleteUserAsync(data?._id));
      //dispatch(getUserAsync(searchText));
      setFlag(true);
    }
  };
  // const onDeactiveClick = () => {
  //   dispatch(deleteUserAsync(selectedSubUser._id));
  //   setselectedSubUser({});
  //   deleteClose();
  // };

  const isDeteleAllow = useIsAccessAllow("user.delete");
  const isEditUserAllow = useIsAccessAllow("user.edit_user");
  return (
    <>
      <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
        <div className="tblmrgn mt-0">
          <div className="mt-5">
            <div>
              <Table
                hover
                responsive
                className="mb-0 default_table with_hoverbtn mrpdng_tbl"
              >
                <thead>
                  <tr>
                    <th width="60px">Sr No.</th>
                    {/* <th>Profile</th> */}
                    <th>Name</th>
                    <th>Email</th>
                    <th>Contact</th>
                    <th>Status</th>
                    <th width="120px">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {subUserList.records && subUserList.records.length ? (
                    subUserList.records.map((subUser, index) => (
                      <tr key={index}>
                        <td>
                          <span className="f-w-500">
                            {subUserSkip * subUserLimit + (index + 1)}
                          </span>
                        </td>
                        {/* <td>
                          <span>
                            <img
                              className="clubImage"
                              src={subUser.profilePicture}
                              alt="profilePicture"
                            ></img>
                          </span>
                        </td> */}
                        <td>
                          <span className="f-w-500">{subUser.name}</span>
                        </td>
                        <td>
                          <span className="f-w-500">{subUser.email}</span>
                        </td>
                        <td>
                          <span className="f-w-500">
                            {subUser.dailCode ? subUser.dailCode : ""}
                            {subUser.contactNumber ? subUser.contactNumber : ""}
                          </span>
                        </td>
                        <td>
                          <span className="f-w-500">{subUser.status}</span>
                        </td>

                        <td>
                          {isEditUserAllow && (
                            <button
                              title="Edit"
                              className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                              onClick={() => onEditClick(subUser)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-primary">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Communication/Write.svg"
                                  )}
                                />
                              </span>
                            </button>
                          )}
                          {isDeteleAllow && (
                            <button
                              title="Delete"
                              className="btn btn-icon btn-light btn-hover-danger btn-sm"
                              onClick={() => onDeleteClick(subUser)}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-danger">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Trash.svg"
                                  )}
                                />
                              </span>
                            </button>
                          )}
                          {/* <a
                          title="Delete"
                          className="btn btn-icon btn-light btn-hover-danger btn-sm"
                          onClick={() => onDeleteClick(subUser)}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/General/Trash.svg"
                              )}
                            />
                          </span>
                        </a> */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No Record Found
                      </td>
                    </tr>
                  )}
                  {isSubUserLoading && (
                    <tr>
                      <td colSpan={7} className="text-center">
                        <div className="basic-verification-loader text-center">
                          {<CircularProgress />}
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            {!isLoading && (
              <div className="modern-pagination" style={{ flex: "0 0 auto", padding: "16px 24px", borderTop: "1px solid #e5e7eb" }}>
                <div className="pagination-info" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: "14px", color: "#6b7280" }}>Show</span>
                    <Select
                      classNamePrefix="react-select"
                      value={defaultPageSize}
                      options={pageSizeOptions}
                      onChange={changePageSize}
                      isSearchable={false}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      styles={{
                        container: (base) => ({
                          ...base,
                          width: 90,
                        }),
                        control: (base, state) => ({
                          ...base,
                          minHeight: 36,
                          height: 36,
                          borderColor: state.isFocused ? "#6993FF" : "#d1d5db",
                          boxShadow: state.isFocused ? "0 0 0 3px rgba(105, 147, 255, 0.1)" : "none",
                          "&:hover": {
                            borderColor: "#6993FF",
                          },
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          padding: "0 10px",
                          height: 36,
                          display: "flex",
                          alignItems: "center",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          fontSize: 13,
                          fontWeight: 500,
                          color: "#111827",
                        }),
                        indicatorSeparator: () => ({ display: "none" }),
                        dropdownIndicator: (base, state) => ({
                          ...base,
                          padding: 6,
                          color: state.isFocused ? "#6993FF" : "#6b7280",
                        }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: 13,
                          padding: "8px 10px",
                          backgroundColor: state.isSelected
                            ? "#6993FF"
                            : state.isFocused
                            ? "#f3f4f6"
                            : "#fff",
                          color: state.isSelected ? "#fff" : "#111827",
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </div>
                  Showing {filteredUsers && filteredUsers.length ? subUserSkip * subUserLimit + 1 : 0} to{" "}
                  {filteredUsers && filteredUsers.length ? Math.min(subUserSkip * subUserLimit + filteredUsers.length, totalRecords) : 0} of {totalRecords} entries
                </div>
                <div className="pagination-controls" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <button 
                    className="page-btn" 
                    onClick={() => onPageChange(subUserSkip - 1)} 
                    disabled={subUserSkip === 0}
                    style={{
                      padding: "6px 12px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      background: subUserSkip === 0 ? "#f3f4f6" : "#fff",
                      color: subUserSkip === 0 ? "#9ca3af" : "#111827",
                      cursor: subUserSkip === 0 ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                      <path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  {(() => {
                    const pages = [];
                    if (totalPages > 0) pages.push(1);
                    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
                      if (!pages.includes(i)) pages.push(i);
                    }
                    if (totalPages > 1 && !pages.includes(totalPages)) pages.push(totalPages);
                    return pages.map((page, idx) => {
                      const showEllipsisBefore = idx > 0 && page - pages[idx - 1] > 1;
                      return (
                        <React.Fragment key={page}>
                          {showEllipsisBefore && <span style={{ padding: "0 4px", color: "#6b7280" }}>...</span>}
                          <button 
                            className={`page-btn ${currentPage === page ? "active" : ""}`} 
                            onClick={() => onPageChange(page - 1)}
                            style={{
                              padding: "6px 12px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              background: currentPage === page ? "#6993FF" : "#fff",
                              color: currentPage === page ? "#fff" : "#111827",
                              cursor: "pointer",
                              minWidth: "36px",
                            }}
                          >
                            {page}
                          </button>
                        </React.Fragment>
                      );
                    });
                  })()}
                  <button
                    className="page-btn"
                    onClick={() => onPageChange(subUserSkip + 1)}
                    disabled={(subUserSkip + 1) * subUserLimit >= totalRecords}
                    style={{
                      padding: "6px 12px",
                      border: "1px solid #d1d5db",
                      borderRadius: "6px",
                      background: (subUserSkip + 1) * subUserLimit >= totalRecords ? "#f3f4f6" : "#fff",
                      color: (subUserSkip + 1) * subUserLimit >= totalRecords ? "#9ca3af" : "#111827",
                      cursor: (subUserSkip + 1) * subUserLimit >= totalRecords ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                      <path d="M6 12l4-4-4-4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <Modal
          show={DeleteModal}
          onHide={deleteClose}
          centered
          className="def_modal delete_modal"
        >
          <Modal.Header>
            <Modal.Title className="fn_s_18 color_blk f-w-700">
              Alert
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form className="form def_form frmwtpddng">
              <p className="fn_s_18 f-w-400 text-center mb-10">
                Are you sure want you to delete?
              </p>
              <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
                <button
                  type="button"
                  className="btn btn-def btn_pdng mr-3"
                  onClick={deleteClose}
                >
                  Keep
                </button>
                <button
                  type="button"
                  className="btn btn-delete btn_pdng"
                  onClick={onDeactiveClick}
                >
                  Yes, Delete
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal> */}
      </div>
    </>
  );
};

export default UserManagementTable;
